// extracted by mini-css-extract-plugin
module.exports = {"container":"DataSharingAgreement_container__1J-yv","sectionTitle":"DataSharingAgreement_sectionTitle__2OGFK","nameContainer":"DataSharingAgreement_nameContainer__3HrYq"};